import types from '../../constants';
import auth from '../../auth';

export function fetchUsers(filter) {
  let url = '/api/users';
  if (filter) {
    const filterAsQueryString = Object.keys(filter).map(k =>
      `${encodeURIComponent(k)}=${encodeURIComponent(filter[k])}`)
    .join('&');

    url += `?${filterAsQueryString}`;
  }
  return async (dispatch) => {
    dispatch({ type: types.USERS_FETCH_START });
    fetch(url, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.USERS_FETCH_END,
          payload: data.users,
        });
      })
      .catch(err => console.log(err)); // eslint-disable-line

    return true;
  };
}

export function fetchCompanies() {
  return async (dispatch) => {
    dispatch({ type: types.COMPANIES_FETCH_START });
    fetch('/api/companies', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.COMPANIES_FETCH_END,
          payload: data.companies,
        });
      })
      .catch(err => console.log(err)); // eslint-disable-line

    return true;
  };
}

export function changeFilter(key, value) {
  return {
    type: types.USERS_CHANGE_FILTER,
    payload: {
      key,
      value,
    },
  };
}

export function resetFilter() {
  return { type: types.USERS_RESET_FILTER };
}

